import { create } from "zustand";
import { CRENEAU_DISPO, DATE_DISPO, LIST_CRENEAU } from "../../Utils/constant";
import { find, getAll } from "../../services/service";
export const useStoreCreneau = create((set) => ({
  loading: false,
  data: [],
  creneaux: [],
  dates: [],
  count: 1,
  creneau: async (param) => {
    set({
      loading: true,
      data: [],
      count: 1,
    });
    try {
      const creneaux = await getAll(LIST_CRENEAU, param, "");
      setTimeout(() => {
        set({
          loading: false,
          data: creneaux.data,
          count: creneaux.data.totalPages,
        });
      }, 800);
    } catch (error) {
      set({
        loading: true,
        data: [],
        count: 1,
      });
    }
  },
  creneauDispo: async (date, numeroTicket) => {
    set({
      loading: true,
      creneaux: [],
    });
    try {
      const creneaux = await find(
        `${CRENEAU_DISPO}?date=${date
          .toLocaleDateString()
          .replace(/\//g, "-")}&numeroTicket=${numeroTicket}`
      );
      set({
        loading: false,
        creneaux: creneaux.data,
      });
    } catch (error) {
      set({
        loading: true,
        creneaux: [],
      });
    }
  },
  dateDispo: async (numeroTicket) => {
    set({
      loading: true,
      dates: [],
    });
    try {
      const creneaux = await find(`${DATE_DISPO}?numeroTicket=${numeroTicket}`);
      set({
        loading: false,
        dates: creneaux.data,
      });
    } catch (error) {
      set({
        loading: true,
        dates: [],
      });
    }
  },
}));
